// ============================================================================
// The work day (2026-10-06): what DevOS's day page ("Now", Today's route in a
// suite whose manifest has `day: 'work'`) carries besides the day's tasks.
// Above the list, what is being waited on and by whom (components/Waiting.tsx:
// Prime's cards answered in place, then what sits with Prime, then what is
// running; 2026-10-10, in place of the old "waiting for you" and "in review"
// lists); under it, what is going out. Nothing about the owner's life: no
// horizon, smoking, wellbeing, dates or the day's cards. Nothing counted.
// ============================================================================
import { useFactoryEnabled } from '@/kinds/agentrun/components'
import { GoingOut } from './GoingOut'
import { WaitingBoard } from './Waiting'

/** Who holds each piece of work in flight; nothing when nothing is. */
export const WaitingForYou = () => (
  <div className="mb-2" data-testid="now-waiting">
    <WaitingBoard />
  </div>
)

/** What is under the list: the way to prod. */
export const WorkUnder = () => {
  const factory = useFactoryEnabled()
  if (!factory) return null
  return <GoingOut />
}
